import React from 'react';
import SyncLoader from 'react-spinners/SyncLoader';
/**
 * add override Css
 * import { css } from "@emotion/core";
 */
export type Props = {
  isLoading: boolean;
  overrideCss?: string;
  color?: string;
  margin?: number;
  size?: number;
};

export const Spinner = (props: Props) => {
  return (
    <div className="sweet-loading">
      <SyncLoader
        css={props.overrideCss}
        size={props.size ? props.size : 16}
        color={props.color ? props.color : '#fff'}
        margin={props.margin ? props.margin : 4}
        loading={props.isLoading}
      />
    </div>
  );
};

export default Spinner;
